export const categories = [
  { id: 'all', name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { id: 'profile', name: '个人资料', slug: 'profile', icon: 'ri-user-heart-line' },
  { id: 'gravure', name: '写真作品', slug: 'gravure', icon: 'ri-camera-lens-line' },
  { id: 'film', name: '影视作品', slug: 'film', icon: 'ri-film-line' },
  { id: 'news', name: '最新动态', slug: 'news', icon: 'ri-flashlight-line' },
  { id: 'interview', name: '访谈专访', slug: 'interview', icon: 'ri-chat-quote-line' },
];

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  date: string;
  author: string;
  tags: string[];
  views: number;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 'sayama-ai-profile-2024',
    title: '佐山爱个人资料全解析：从出道到现在的完整轨迹',
    excerpt: '佐山爱，1994年出生于日本东京都，是日本知名女演员及写真偶像。她以清纯甜美的外表和出色的表现力赢得了大量粉丝的喜爱。本文将全面解析佐山爱的出道经历与成长轨迹。',
    content: `<p>佐山爱（Sayama Ai），1994年3月15日出生于日本东京都，身高162cm，B型血，是日本知名女演员及写真偶像。</p>
<h2>出道经历</h2>
<p>佐山爱于2012年以写真偶像身份正式出道，当时年仅18岁的她凭借清纯甜美的外表迅速引起了业界关注。出道初期，她主要为多家知名杂志拍摄写真，以清新自然的气质赢得了大量粉丝的喜爱。</p>
<p>2014年，佐山爱开始涉足影视领域，出演了多部电视剧和电影作品。她不仅在演技上不断精进，还保持了写真方面的高产出，成为同时活跃在写真界和影视界的双栖艺人。</p>
<h2>事业高峰期</h2>
<p>2016年至2019年是佐山爱事业的高峰期。期间她发行了多本个人写真集，每一本都取得了优异的销量成绩。同时，她参演的影视作品也获得了不错的评价，逐渐从偶像派向实力派转型。</p>
<h2>近期动态</h2>
<p>2023年以来，佐山爱继续活跃在演艺圈，参与了多个综艺节目的录制，并在社交媒体上与粉丝保持密切互动。她的Instagram粉丝数已突破百万，是日本最受欢迎的女性艺人之一。</p>
<h2>个人特点</h2>
<p>佐山爱以甜美的笑容和亲和力著称。她热爱旅行和美食，经常在社交平台分享日常生活。除了演艺工作外，她还热衷于公益事业，多次参与慈善活动。</p>`,
    category: 'profile',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20portrait%20elegant%20studio%20photography%20soft%20natural%20lighting%20warm%20tones%20cream%20background%20minimal%20aesthetic%20editorial%20style%20high%20detail%20professional%20headshot&width=800&height=500&seq=sayama-profile-2024&orientation=landscape',
    date: '2024-12-15',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '个人资料', '出道经历', '演艺生涯'],
    views: 32850,
    featured: true,
  },
  {
    id: 'sayama-gravure-best-2024',
    title: '佐山爱2024年最佳写真精选：镜头下的绝美瞬间',
    excerpt: '2024年佐山爱为多本杂志拍摄了精彩的写真作品，从海滩到都市，从甜美到成熟，展现了多样的魅力。本文精选了2024年最具代表性的写真作品。',
    content: `<p>2024年对于佐山爱来说是一个充满惊喜的年份。她在写真领域持续发力，为多本知名杂志拍摄了令人惊艳的写真作品。</p>
<h2>春季写真 - 樱花物语</h2>
<p>2024年春季，佐山爱在京都拍摄了一组以樱花为主题的写真。身穿和服的她漫步在古都的樱花树下，将日式传统美学与现代写真艺术完美融合。这组写真在《周刊现代》杂志上刊登后引发了热烈反响。</p>
<h2>夏季写真 - 冲绳之夏</h2>
<p>夏季，佐山爱前往冲绳拍摄了一组海滩主题写真。碧海蓝天下，她展现出了与以往甜美形象不同的一面——更加成熟、自信且充满活力。这组写真被粉丝誉为"2024年最美的夏季记忆"。</p>
<h2>秋季写真 - 都市光影</h2>
<p>秋季的佐山爱回归都市，在东京的街头和天台拍摄了一组都市风格写真。霓虹灯光下的她散发着迷人的都市女性魅力，展现了多面的表现力。</p>
<h2>冬季写真 - 雪国浪漫</h2>
<p>年末，佐山爱前往北海道拍摄了冬日主题写真。在银装素裹的雪景中，她展现出了清冷而温柔的气质，为2024年画上了完美的句号。</p>`,
    category: 'gravure',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20model%20elegant%20photoshoot%20studio%20portrait%20warm%20lighting%20cream%20minimalist%20background%20fashion%20editorial%20soft%20aesthetic%20high%20quality%20professional%20photography&width=800&height=500&seq=sayama-gravure-2024&orientation=landscape',
    date: '2024-12-10',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '写真', '写真集', '2024精选'],
    views: 45120,
    featured: true,
  },
  {
    id: 'sayama-film-works-overview',
    title: '佐山爱影视作品全盘点：从配角到主演的蜕变之路',
    excerpt: '佐山爱在影视领域的表现同样出色。从2014年首次触电至今，她已参演超过20部影视作品。本文为您盘点佐山爱最重要的影视代表作。',
    content: `<p>佐山爱的影视之路始于2014年，虽然起步不算早，但她凭借勤奋和天赋，在短短几年间完成了从配角到主演的蜕变。</p>
<h2>电视剧作品</h2>
<p>2015年，佐山爱首次出演电视剧《恋爱的季节》，在剧中饰演女主角的好友角色。虽然戏份不多，但她自然的表演获得了导演的认可。</p>
<p>2017年，她在《东京女子物语》中获得了重要配角，饰演一位追求梦想的年轻设计师。这个角色让更多观众认识了她作为演员的一面。</p>
<p>2019年，佐山爱首次担任电视剧女主角，在《月光下的约定》中饰演一位温柔坚韧的护士。该剧收视率表现优异，她的演技也获得了广泛好评。</p>
<h2>电影作品</h2>
<p>2016年，佐山爱出演了电影处女作《夏日记忆》，在片中饰演一位高中生。虽然只是配角，但她的表现令人印象深刻。</p>
<p>2020年，她在电影《东京夜未眠》中饰演女主角，这部作品入围了多个国际电影节，也让佐山爱的演技得到了更多认可。</p>
<h2>最新作品</h2>
<p>2024年，佐山爱参演了Netflix原创剧集《东京故事》，该剧在全球范围内播出，让更多海外观众认识了这位才华横溢的日本女演员。</p>`,
    category: 'film',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20film%20set%20professional%20lighting%20cinematic%20mood%20warm%20tones%20elegant%20portrait%20soft%20background%20movie%20scene%20atmosphere%20high%20quality%20editorial&width=800&height=500&seq=sayama-film-works&orientation=landscape',
    date: '2024-11-28',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '影视作品', '电视剧', '电影', '盘点'],
    views: 28900,
    featured: true,
  },
  {
    id: 'sayama-news-2025-jan',
    title: '佐山爱最新动态：2025年新年企划正式公布',
    excerpt: '佐山爱在社交平台公布了2025年新年企划，包括新的写真集发行计划、综艺节目出演以及粉丝见面会安排等多项重磅消息。',
    content: `<p>2025年1月1日，佐山爱通过个人Instagram和官方粉丝站同步公布了新一年的工作计划，引发了粉丝们的热烈讨论。</p>
<h2>新写真集发行计划</h2>
<p>佐山爱宣布将于2025年春季发行全新个人写真集《Bloom》。这本写真集将在冲绳和北海道两地取景拍摄，由知名摄影师操刀，预计将成为她职业生涯中最重要的一部写真作品。</p>
<h2>综艺节目出演</h2>
<p>2025年第一季度，佐山爱将作为常驻嘉宾参加多档日本热门综艺节目，包括《VS岚》、《闲聊007》等。这也是她首次以常驻嘉宾身份参加黄金时段综艺节目。</p>
<h2>粉丝见面会</h2>
<p>为庆祝出道13周年，佐山爱计划在2025年3月在东京、大阪和名古屋三地举办粉丝见面会。见面会将包含互动游戏、现场拍摄和签名环节。</p>
<h2>社交媒体互动</h2>
<p>佐山爱表示2025年将加大在社交媒体上的互动频率，计划每月进行一次直播，与全球粉丝进行实时交流。</p>`,
    category: 'news',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20celebrity%20press%20conference%20elegant%20studio%20setting%20warm%20lighting%20professional%20photography%20modern%20minimalist%20aesthetic%20soft%20cream%20background%20high%20quality&width=800&height=500&seq=sayama-news-2025&orientation=landscape',
    date: '2025-01-01',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '最新动态', '2025', '写真集', '粉丝见面会'],
    views: 52300,
    featured: true,
  },
  {
    id: 'sayama-interview-2024-autumn',
    title: '独家专访：佐山爱谈十年演艺之路的心路历程',
    excerpt: '在出道12周年之际，佐山爱接受了本粉丝站的独家专访。她回顾了从青涩新人到成熟艺人的成长历程，分享了幕后的故事与感悟。',
    content: `<p>2024年秋天，在佐山爱出道12周年之际，我们有幸对她进行了一次深度专访。在这次长达两小时的对话中，佐山爱敞开心扉，分享了她的心路历程。</p>
<h2>关于出道</h2>
<p><strong>"刚出道时真的什么都不懂，很紧张也很兴奋。每次拍摄前都会反复练习表情和姿势，生怕做得不够好。"</strong>回忆起出道时的青涩时光，佐山爱笑得很温暖。</p>
<h2>关于挑战</h2>
<p>谈到职业生涯中最大的挑战，佐山爱坦言是从写真偶像到演员的转型。<strong>"很多人对写真偶像有刻板印象，认为我们只会拍照。我想证明自己可以做更多。"</strong></p>
<h2>关于未来</h2>
<p>展望未来，佐山爱表示希望能尝试更多不同类型的角色。<strong>"我想挑战悬疑剧和喜剧，让大家看到更多面的佐山爱。"</strong></p>
<h2>给粉丝的话</h2>
<p>在采访的最后，佐山爱向一直支持她的粉丝表达了感谢：<strong>"没有你们的支持，就没有今天的佐山爱。我会继续努力，成为让你们骄傲的艺人。"</strong></p>`,
    category: 'interview',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20actress%20interview%20portrait%20elegant%20studio%20lighting%20warm%20atmosphere%20minimalist%20cream%20background%20professional%20photography%20soft%20expression%20high%20quality&width=800&height=500&seq=sayama-interview-2024&orientation=landscape',
    date: '2024-10-20',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '专访', '访谈', '演艺之路', '心路历程'],
    views: 37800,
    featured: false,
  },
  {
    id: 'sayama-gravure-collection-2023',
    title: '佐山爱写真集《花语》全赏析：每一页都是艺术品',
    excerpt: '佐山爱2023年发行的写真集《花语》被誉为她的代表作之一。本文带您逐章解析这本充满艺术感的写真集，感受佐山爱的多样魅力。',
    content: `<p>2023年发行的写真集《花语》是佐山爱职业生涯中的又一里程碑。这本写真集历时半年拍摄，横跨日本多个城市取景，每一页都经过了精心的构思和设计。</p>
<h2>第一章：春 · 樱</h2>
<p>写真集以京都的樱花季开篇。佐山爱身着浅粉色和服，在樱花树下展现出了日式传统美学与现代之美的融合。摄影师巧妙地运用了自然光线，让每一张照片都如同画卷般优美。</p>
<h2>第二章：夏 · 海</h2>
<p>夏季篇章在湘南海岸拍摄。佐山爱以清新的夏日装扮出镜，海风、沙滩、阳光构成了充满活力的夏日画卷。这一章节展现了她活泼开朗的一面。</p>
<h2>第三章：秋 · 城</h2>
<p>秋季取景于金泽古城。佐山爱身着复古风格服装，在古老的街道和建筑间穿梭，营造出浓厚的怀旧氛围。</p>
<h2>第四章：冬 · 雪</h2>
<p>冬季篇章在北海道拍摄。银装素裹的世界里，佐山爱展现出了冷艳而温柔的双重魅力，为整本写真集画上了完美的句号。</p>`,
    category: 'gravure',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20photo%20book%20elegant%20layout%20warm%20minimalist%20studio%20photography%20soft%20lighting%20cream%20background%20artistic%20fashion%20editorial%20high%20quality%20aesthetic&width=800&height=500&seq=sayama-gravure-collection&orientation=landscape',
    date: '2023-08-15',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '写真集', '花语', '写真赏析'],
    views: 21400,
    featured: false,
  },
  {
    id: 'sayama-charity-2024',
    title: '佐山爱参与慈善活动：用爱心温暖更多人',
    excerpt: '佐山爱不仅是一位优秀的艺人，更是一位热心公益的慈善使者。本文回顾了她2024年参与的各类慈善活动。',
    content: `<p>除了在演艺事业上不断突破，佐山爱在公益慈善领域同样不遗余力。2024年，她参与了多项慈善活动，用自己的影响力为社会贡献力量。</p>
<h2>儿童教育支持</h2>
<p>2024年3月，佐山爱访问了东京都内多所小学，参与阅读推广活动。她亲自为孩子们朗读绘本，并捐赠了一批图书给学校图书馆。</p>
<h2>灾害募捐</h2>
<p>2024年能登半岛地震发生后，佐山爱第一时间通过社交媒体呼吁粉丝关注灾区，并个人捐款500万日元用于灾后重建。</p>
<h2>环保倡议</h2>
<p>2024年世界环境日，佐山爱参与了海滩清洁活动，并录制了环保宣传视频，呼吁大众关注海洋环境保护。</p>`,
    category: 'news',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20celebrity%20charity%20event%20warm%20atmosphere%20community%20service%20elegant%20portrait%20soft%20lighting%20minimalist%20cream%20background%20professional%20photography%20heartwarming&width=800&height=500&seq=sayama-charity-2024&orientation=landscape',
    date: '2024-09-05',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '慈善', '公益', '社会责任'],
    views: 18900,
    featured: false,
  },
  {
    id: 'sayama-style-fashion-2024',
    title: '佐山爱的时尚穿搭进化史：从甜美到优雅',
    excerpt: '从出道初期的甜美少女风到如今的优雅成熟范，佐山爱的时尚品味经历了令人惊艳的蜕变。本文回顾她的穿搭进化之路。',
    content: `<p>佐山爱的时尚风格在12年间发生了显著的变化，从青涩的少女风格逐渐蜕变为成熟优雅的女性魅力。</p>
<h2>2012-2014：甜美少女期</h2>
<p>出道初期的佐山爱偏好蕾丝、蝴蝶结等甜美元素，整体风格偏向日系可爱风格，符合她当时清新甜美的形象定位。</p>
<h2>2015-2018：转型探索期</h2>
<p>随着事业的多元化发展，佐山爱开始尝试更多风格的穿搭。从休闲街头风到简约通勤装，她的时尚选择变得更加多样化。</p>
<h2>2019-2022：成熟优雅期</h2>
<p>进入20代后半段，佐山爱的风格逐渐稳定，偏向简约优雅路线。她频繁出现在时尚杂志中，成为许多品牌的合作对象。</p>
<h2>2023至今：自信多元化</h2>
<p>如今的佐山爱已经形成了独特的个人风格。无论是红毯礼服还是日常休闲装，她都能轻松驾驭，展现出自信从容的魅力。</p>`,
    category: 'profile',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20fashion%20model%20elegant%20studio%20portrait%20minimalist%20cream%20background%20warm%20lighting%20professional%20photography%20stylish%20outfit%20aesthetic%20high%20quality&width=800&height=500&seq=sayama-style-fashion&orientation=landscape',
    date: '2024-08-22',
    author: '佐山爱粉丝站编辑',
    tags: ['佐山爱', '时尚', '穿搭', '风格进化'],
    views: 25600,
    featured: false,
  },
];